import { Theme } from '@mui/material'

import makeStyles from '@mui/styles/makeStyles'

type StylesType = {
  hidden: boolean
}

const useStyles = makeStyles<Theme, StylesType>(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: ({ hidden }) => (hidden ? '1rem' : '0')
  },

  dropArea: {
    border: '3px solid transparent',
    boxSizing: 'border-box',
    height: '0.5rem'
  },

  dropTop: {
    borderBottomColor: 'lightgray'
  },

  dropBot: {
    borderTopColor: 'lightgray'
  },

  drag: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'grab'
  },

  setting: {
    display: 'flex',
    alignItems: 'center',

    '& > :not(:last-child)': {
      marginRight: '1rem',
      fontSize: theme.size.base
    }
  }
}))

export default useStyles
